module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.block.fields.content),
      expression: "block.fields.content"
    }],
    class: ['bb8-form-control', 'bb8-block-' + _vm.blockCss],
    attrs: {
      "placeholder": "…",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.block.fields.content)
    },
    on: {
      "keydown": function($event) {
        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
        _vm.removeBlock($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.block.fields.content = $event.target.value
      }
    }
  }), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a755ccc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/SingleTextMixin.vue
// module id = 43
// module chunks = 0